<template>
  <div class="loadingSpin">
    <ProgressSpinner />
  </div>
</template>
<style lang="less" scoped>
.loadingSpin {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
